import { FormEvent, useState } from "react";
import SpinnerLoader from "../../../../components/loader/spinner-loader";
import { SuccessFlash } from "../../../../components/helper/flash-notification";
import InputField from "../../../../components/form/input-field";
import { numberWithCommas } from "../../../../lib/helper-support";
import { useApi } from "../../../../providers/ApiProvider";

type UserTransactionLimitType = {
  user?: any;
};

const UserTransactionLimit = ({ user }: UserTransactionLimitType) => {
  const api = useApi();
  const [showModal, setShowModal] = useState<boolean>(false);

  const [bank_transfer_limit, setBankTransferLimit] = useState<string>(
    user?.transaction_limit?.bank_transfer ?? "0",
  );
  const [bank_transfer_limitError, setBankTransferLimitError] = useState<
    string | null
  >(null);

  const [airtime_limit, setAirtimeLimit] = useState<string>(
    user?.transaction_limit?.airtime ?? "0",
  );
  const [airtime_limitError, setAirtimeLimitError] = useState<string | null>(
    null,
  );

  const [internet_data_limit, setInternetDataLimit] = useState<string>(
    user?.transaction_limit?.internet_data ?? "0",
  );
  const [internet_data_limitError, setInternetDataLimitError] = useState<
    string | null
  >(null);

  const submitForm = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const request = await api.POST({
      endpoint: `users/${user?.phone_number}/setTransactionLimit`,
      payload: {
        bank_transfer: bank_transfer_limit,
        airtime: airtime_limit,
        internet_data: internet_data_limit,
      },
      refreshKeys: ["users", user.phone_number],
    });

    if (!request) return;

    SuccessFlash("User transaction limit updated successfully.");

    setShowModal(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowModal(true)}
        type="button"
        className="flex items-center space-x-2 rounded-md border-primary hover:bg-opacity-90 input w-fit"
      >
        <span>Transaction limit</span>
      </button>
      {
        <div>
          <div
            className={`${showModal ? "flex" : "hidden"} overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full`}
          >
            <div className="relative w-full max-w-lg max-h-full p-4">
              <div className="relative bg-white rounded-lg shadow">
                <form onSubmit={submitForm} className="p-4 text-center md:p-5">
                  <h3 className="my-5 mb-5 text-lg font-normal text-tertiary">
                    Transaction Limit
                  </h3>
                  <div className="grid gap-4 mb-5 text-left">
                    <InputField
                      value={bank_transfer_limit}
                      label="Bank transfer limit"
                      type="number"
                      onChangeInput={(e) => [
                        setBankTransferLimit(e.target.value),
                        setBankTransferLimitError(null),
                      ]}
                      error={bank_transfer_limitError}
                    />
                    <p className="font-[400] text-[12px]">
                      {numberWithCommas(bank_transfer_limit ?? 0)}
                    </p>
                    <InputField
                      value={airtime_limit}
                      label="Airtime limit"
                      type="number"
                      onChangeInput={(e) => [
                        setAirtimeLimit(e.target.value),
                        setAirtimeLimitError(null),
                      ]}
                      error={airtime_limitError}
                    />
                    <p className="font-[400] text-[12px]">
                      {numberWithCommas(airtime_limit ?? 0)}
                    </p>
                    <InputField
                      value={internet_data_limit}
                      label="Internet data limit"
                      type="number"
                      onChangeInput={(e) => [
                        setInternetDataLimit(e.target.value),
                        setInternetDataLimitError(null),
                      ]}
                      error={internet_data_limitError}
                    />
                    <p className="font-[400] text-[12px]">
                      {numberWithCommas(internet_data_limit ?? 0)}
                    </p>
                  </div>
                  <button
                    disabled={api.postLoading}
                    type="submit"
                    className="text-white space-x-2 bg-primary hover:bg-tertiary focus:ring-4 focus:outline-none  font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center"
                  >
                    <span>Save changes</span>
                    {api.postLoading && <SpinnerLoader />}
                  </button>
                  <button
                    disabled={api.postLoading}
                    onClick={() => setShowModal(!showModal)}
                    type="button"
                    className="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 "
                  >
                    Cancel
                  </button>
                </form>
              </div>
            </div>
          </div>
          <div
            className={`fixed inset-0 z-40 bg-gray-900/50 ${showModal ? "" : "hidden"}`}
          ></div>
        </div>
      }
    </div>
  );
};

export default UserTransactionLimit;
